import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { FeedActivityFragment } from '@spotify/confidence-graphql';

export interface FeedItemOptions {
  activity: FeedActivityFragment;
}

export interface FeedItemExtensionOptions
  extends ItemRenderExtensionOptions<FeedItemOptions> {}

export const FeedItemExtensions = createItemRenderExtensions({
  id: 'feed-item',
});

export const useFeedItemExtensions = () => {
  return useItemRenderExtensions<FeedItemExtensionOptions>(FeedItemExtensions);
};

export const createFeedItemExtension = (options: FeedItemExtensionOptions) => {
  return createItemRenderExtension<FeedItemExtensionOptions>(options);
};
